export default __webpack_public_path__ + "static/newsroom-3b4bd042508ed79a889a2dca96d68891.webp";